export enum Routes {
  SignIn = '/sign-in',
  Home = '/',

  Models = '/models',
  NewModel = '/models/new',
  ModelDetails = '/models/:id',

  ModelSizes = '/models/sizes',
  NewModelSize = '/models/sizes/new',
  ModelSizeDetails = '/models/sizes/:id',

  Styles = '/styles',
  NewStyle = '/styles/new',
  StyleDetails = '/styles/:id',

  EventDetails = '/events/:id',
  Events = '/events',

  Overlays = '/overlays',
  NewOverlay = '/overlays/new',
  OverlayDetails = '/overlays/:id',

  Masks = '/masks',
  NewMask = '/masks/new',
  MaskDetails = '/masks/:id',

  PrivacyPolicy = '/privacy-policy',
  InstancesManager = '/instances',

  Gcrs = '/gcrs',
  NewGcr = '/gcrs/new',
  GcrDetails = '/gcrs/:id',

  SystemPrompts = '/system-prompts',
  SystemPromptsNewPrompt = '/system-prompts/new-prompt',

  TextStyles = '/text-styles',
  NewTextStyle = '/text-styles/new',
  TextStyleDetails = '/text-styles/:id',

  NotificationTemplates = '/notification-templates',

  Downloads = '/downloads',
}
